import { ColorEnum } from '@/constants/color'
import { FontEnum } from '@/constants/font'
import { useIntervaledState } from '@/hooks/useIntervalState'
import dayjs from 'dayjs'
import { FC } from 'react'
import { StyleSheet, Text } from 'react-native'

const getTime = () => dayjs().format('HH:mm')

const ExtendedMainHeaderTime: FC = () => {
    const time = useIntervaledState(getTime, 60000)

    return <Text style={styles.time}>{time}</Text>
}

const styles = StyleSheet.create({
    time: {
        color: ColorEnum.WHITE,
        fontFamily: FontEnum.SatoshiBold,
        fontSize: 18,
        marginLeft: 16,
    },
})

export default ExtendedMainHeaderTime
